import { Navigate } from 'react-router-dom';
import { usePermissions } from '../../contexts/PermissionContext';
import { TokenService } from '../../lib/tokenService';
import {
  EMBEDDED_ENTRY_ROUTE,
  getStoredEmbeddedScreenState,
  getStoredShellMode
} from '../../lib/embeddedShell';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { userInfo } = usePermissions();
  const hasValidToken = TokenService.hasValidToken();
  const shellMode = getStoredShellMode();
  const embeddedScreenState = getStoredEmbeddedScreenState();
  const allowEmbeddedHold =
    shellMode === 'embedded' &&
    !!userInfo &&
    embeddedScreenState !== 'authenticated';

  if ((!userInfo || !hasValidToken) && !allowEmbeddedHold) {
    const fallbackRoute = shellMode === 'embedded'
      ? EMBEDDED_ENTRY_ROUTE
      : '/login';

    console.warn('[ProtectedRoute] Acesso nao autorizado - redirecionando', {
      hasUserInfo: !!userInfo,
      hasValidToken,
      embeddedScreenState,
      fallbackRoute
    });

    return <Navigate to={fallbackRoute} replace />;
  }

  return <>{children}</>;
}
